module.exports = __webpack_public_path__ + "img/mission_name_panel.d3f0e1c5.png";